import { Button, Modal, Space } from "antd"
import React, { useRef } from "react"
import { openPictureInPicture } from "../../pip"
import { DataType } from "../.."
import { markAIState } from "../../../../../services/ai"

interface AiActionProps {
  thumb: DataType
  onLoad: ()=> void
  onReset: ()=> void
}

const AiAction: React.FC<AiActionProps> = ({ thumb, onLoad, onReset })=> {

  const reasonRef = useRef<HTMLTextAreaElement>(null)

  const handleReset = ()=> {
    Modal.confirm({
      title: '操作确认？',
      content: (
        <Space direction="vertical" style={{width: '100%'}}>
          <p>点击确定后图片将恢复到原始状态？</p>
          <textarea ref={reasonRef} placeholder="请输入不准确原因" style={{borderRadius: 5, border: '1px solid #aeaeae', resize: 'none', width: '100%', padding: '4px 8px', outline: 'none'}}/>
        </Space>
      ),
      okText: '确定',
      cancelText: '取消',
      onOk: async ()=> {
        window.__mosaic_ignore_url = true
        await markAIState(thumb.aiImageId, reasonRef.current?.value || '')
        onReset()
      }
    })
  }

  // 图片地址相同时为脱敏失败
  return (
    <>
      <Button disabled={!thumb._url} onClick={handleReset} type="text" shape="round" danger>识别不准?</Button>
      <Button disabled={thumb.maskUrl === thumb.url} onClick={onLoad} type="primary" shape="round" ghost style={{marginLeft: 20}}>载入脱敏图片</Button>
    </>
  )
}

export default AiAction